import { Configuration } from "Infrastructure/Config/config";

export const AppRouting = {
  Base: {
    path: () => "/",
  },
  ErrorSignIn: {
    path: () => "/sign-in-400",
  },
  Error403: {
    path: () => "/403",
  },
  Error404: {
    path: () => "/404",
  },
  OAuthCallback: {
    path: () => "/oauth",
  },
  Dashboard: {
    path: () => "/dashboard",
  },
  Analyses: {
    path: () => "/analyses",
  },
  NewAnalysis: {
    path: () => "/analyses/new",
  },
  AnalysisDetail: {
    route: "/analyses/:analysisId/version/:versionId",
    path: (analysisId: string, versionId: string) => `/analyses/${analysisId}/version/${versionId}`,
  },
  AnalysisDocument: {
    route: "/analyses/:analysisId/version/:versionId/document",
    path: (analysisId: string, versionId: string) => `/analyses/${analysisId}/version/${versionId}/document`,
  },
  QuestionnaireDocument: {
    route: "/analyses/:analysisId/version/:versionId/questionnaire-document/:type",
    path: (analysisId: string, versionId: string, type: "empty" | "filled") =>
      `/analyses/${analysisId}/version/${versionId}/questionnaire-document/${type}`,
  },
  Clients: {
    path: () => "/clients",
  },
  FAQ: {
    path: () => "/faq",
  },
  LegacyReportIssue: {
    path: () => "/report-issue",
  },
  PdfTemplate: {
    path: () => "/pdf-template",
  },
  PdfTemplateHeader: {
    path: () => "/pdf-template/:analysisId/version/:versionId/header",
  },
  PdfTemplateFooter: {
    path: () => "/pdf-template/footer",
  },
  PdfTemplateContent: {
    path: () => "/pdf-template/:analysisId/version/:versionId/content",
  },
  PdfTemplateQuestionnaireEmpty: {
    path: () => "/pdf-template/:analysisId/version/:versionId/questionnaire-empty",
  },
  PdfTemplateQuestionnaire: {
    path: () => "/pdf-template/:analysisId/version/:versionId/questionnaire",
  },
  PdfTemplateQuestionnaireEvaluation: {
    path: () => "/pdf-template/:analysisId/version/:versionId/questionnaire-evaluation",
  },
  NsureInvestmentCallback: {
    route: "/nsure_callback/investment/:caseId",
    path: (caseId: string) => `/nsure_callback/investment/${caseId}`,
  },
} as const;

export const AdminRouting = {
  ClientContracts: {
    path: () => "/client-contracts",
  },
} as const;

export const getAdminUrl = (path: string) => `${Configuration.getAdminUrl()}${path}`;

type RouteObject<T extends any[] = any[]> = {
  route?: string;
  path: (...args: T) => string;
};

export function getRoute<T extends RouteObject>(routeObj: T): string {
  return routeObj.route ?? routeObj.path();
}

export const toKebabCase = (value: string) => value.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

export const getUrl = (url: string, params?: Record<string, string>): string => {
  if (!params) return url;

  const queryString = new URLSearchParams();

  for (const key of Object.keys(params)) {
    queryString.append(key, params[key]);
  }

  return `${url}?${queryString.toString()}`;
};
